import Vue from 'vue'
import Vuex from 'vuex'
import managerStore from '@/store/managerStore'
import positionStore from '@/store/positionStore'
import serviceStore from '@/store/serviceStore'
import adminPermissionStore from '@/store/adminPermissionStore'
import hail from '@/store/hail'
import hailState from '@/store/hailState'
import hailStateV2 from '@/store/hailStateV2'
import transaction from '@/store/transaction'
import reservation from '@/store/reservation'
import reserveModal from '@/store/reserveModal'
import driverMonitor from '@/store/driverMonitor'
import landmark from '@/store/landmark'
import googlemap from '@/store/googlemap'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    managerStore,
    positionStore,
    serviceStore,
    adminPermissionStore,
    hail,
    hailState,
    hailStateV2,
    transaction,
    reservation,
    reserveModal,
    driverMonitor,
    landmark,
    googlemap,
  },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js